module.exports = __webpack_public_path__ + "static/media/arrowRightPurple.31e8c5ca.svg";